document.addEventListener('DOMContentLoaded', () => {
  // Announcement bar rotation
  const ann = document.querySelector('[data-announcement]');
  if (ann) {
    const slides = Array.from(ann.querySelectorAll('.announcement-slide'));
    let aIndex = 0;
    if (slides.length > 1) {
      setInterval(() => {
        slides[aIndex].classList.remove('is-active');
        aIndex = (aIndex + 1) % slides.length;
        slides[aIndex].classList.add('is-active');
      }, 4500);
    }
  }

  const slideshows = document.querySelectorAll('[data-slideshow]');
  slideshows.forEach((show) => {
    const slides = Array.from(show.querySelectorAll('[data-slide]'));
    const dots = Array.from(show.querySelectorAll('[data-dot]'));
    const prev = show.querySelector('[data-prev]');
    const next = show.querySelector('[data-next]');
    let index = 0;

    const go = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    if (!slides.length) return;
    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    setInterval(() => go(index + 1), 6500);
    go(0);
  });

  // ===== Product page: gallery, variants, qty, accordion =====
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        thumbs.forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
        main && main.setAttribute('src', t.dataset.full);
      });
    });
  }

  const form = document.getElementById('product-form');
  if (form) {
    const variantData = Array.from(form.querySelectorAll('.variant-data')).map((s) => ({
      id: s.dataset.id,
      options: (s.dataset.options || '').split('||'),
    }));
    const selects = Array.from(form.querySelectorAll('.option-select'));
    const variantId = form.querySelector('[data-variant-id]');
    const status = form.querySelector('[data-form-status]');

    const update = () => {
      const chosen = selects.map((s) => s.value);
      const match = variantData.find((v) =>
        v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
      );
      if (match && variantId) {
        variantId.value = match.id;
        status && status.classList.remove('error');
      }
    };
    selects.forEach((s) => s.addEventListener('change', update));
    update();

    const qtyInput = form.querySelector('[data-qty-input]');
    const minus = form.querySelector('[data-qty-minus]');
    const plus = form.querySelector('[data-qty-plus]');
    if (qtyInput && minus) minus.addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qtyInput && plus) plus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    const addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn) {
      form.addEventListener('submit', (e) => {
        if (!form.querySelector('input[name="id"]').value) {
          e.preventDefault();
          if (status) { status.hidden = false; status.classList.add('error'); status.textContent = 'Please select a variant.'; }
          return;
        }
        if (status) { status.hidden = false; status.classList.add('ok'); status.textContent = 'Added to cart ✓'; }
      });
    }
  }

  const accordion = document.querySelector('[data-accordion]');
  if (accordion) {
    accordion.querySelectorAll('.accordion-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.accordion-item');
        const open = item.classList.contains('is-open');
        accordion.querySelectorAll('.accordion-item').forEach((i) => i.classList.remove('is-open'));
        if (!open) item.classList.add('is-open');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }
});
